import { useEffect, useState } from 'react'

import { getApplicationComments } from 'api/application'
import { OctaneLogger } from 'integrations/datadog/OctaneLogger'

export interface UseApplicationCommentsInterface {
    applicationComments: ApplicationCommentInterface[]
    loading: boolean
    error: Error | null
}

export interface ApplicationCommentInterface {
    id: number
    user: number
    application: number
    text: string
    created: string
    is_read: boolean
    notify: boolean
    user_first_name: string
    user_last_name: string
    by_lender: boolean
    by_dealer: boolean
    content_type: string
}

const useApplicationComments = (
    applicationId: number,
): UseApplicationCommentsInterface => {
    const [applicationComments, setApplicationComments] = useState<
        ApplicationCommentInterface[]
    >([])

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        const abortController = new AbortController()

        const loadApplicationComments = async () => {
            return getApplicationComments(applicationId, abortController)
        }

        if (!applicationId) {
            return
        }

        loadApplicationComments()
            .then((comments: ApplicationCommentInterface[]) => {
                setError(null)
                setApplicationComments(comments)
            })
            .catch((applicationCommentError) => {
                OctaneLogger.error(
                    'Error when getting application comments.',
                    { application: { id: applicationId } },
                    applicationCommentError as Error,
                )

                setError(applicationCommentError)
            })
            .finally(() => {
                setLoading(false)
            })

        return () => abortController.abort()
    }, [applicationId])

    return {
        applicationComments,
        loading,
        error,
    }
}

export default useApplicationComments
